
import { AiFillInstagram } from "react-icons/ai";
import { AiOutlineGithub} from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";

const data = [
    {id: 1, link: 'https://instagram.com', icon: <AiFillInstagram/>},
    {id: 2, link: 'https://twitter.com', icon: <AiOutlineTwitter/>},
    {id: 3, link: 'https://Githup.com', icon: <AiOutlineGithub/>},
    {id: 4, link: 'https://linkedin.com', icon: <AiFillLinkedin/>}
]
export default data